import { Injectable, inject } from "@angular/core";
import { EditionServiceServiceProxy, BuyAdditionalFeatureRequest } from "@shared/api/service-proxies";
import { AvailableAdditionalItemSection, CustomerGatewayInfoRequest, CustomersApi, SubscriptionApi } from "libs/subscription/src/api/proxies";
import { Observable } from "rxjs";

export enum PaymentGateway {
    Superlogica,
    Vindi
}

@Injectable()
export class EditionService {
    private _api = inject(EditionServiceServiceProxy);
    private _subscriptionApi = inject(SubscriptionApi);
    private _customerApi = inject(CustomersApi);


    getGatewayInfo(tenantId: number) {
        return this._customerApi.gatewayInfoGet(tenantId);
    }

    updateGatewayInfo(tenantId: number, customerExternalId: string, subscriptionExternalId: string, gatewayId: number) {
        let request = CustomerGatewayInfoRequest.fromJS({
            customerExternalId: customerExternalId,
            subscriptionExternalId: subscriptionExternalId,
            paymentGateway: gatewayId,
        });

        return this._customerApi.gatewayInfoPatch(tenantId, request);
    }

    getTenantFeaturesUsage(featureName?: string) {
        return this._api.getTenantFeaturesUsage(featureName);
    }

    getAvailableAdditionalItems(): Observable<AvailableAdditionalItemSection[]> {
        return this._subscriptionApi.availableAdditionalItems(true);
    }

    acquireFeature(params: BuyAdditionalFeatureRequest) {
        let request = BuyAdditionalFeatureRequest.fromJS(params);
        return this._api.buyAdditionalFeature(request);
    }
}
